import { RecordsTable, type Column } from '../components/RecordsTable/RecordsTable';

interface GapRow {
  sku_id: number;
  sku_code: string;
  nominal_label: string;
  merv: number;
  pack_count: number;
  missing_amazon: boolean;
}

function gapCell(missing: boolean) {
  return missing ? (
    <span className="records__tag records__tag--warn">Missing</span>
  ) : (
    <span className="records__tag records__tag--ok">Linked</span>
  );
}

const COLUMNS: Column<GapRow>[] = [
  { key: 'sku_code', header: 'SKU code' },
  { key: 'nominal_label', header: 'Size' },
  { key: 'merv', header: 'MERV', numeric: true },
  { key: 'pack_count', header: 'Pack', numeric: true },
  { key: 'missing_amazon', header: 'Amazon', render: (r) => gapCell(r.missing_amazon) },
];

export function ListingGaps() {
  return (
    <RecordsTable<GapRow>
      title="Listing Gaps"
      intro="Active SKUs with no Amazon ASIN. The ASIN stays meaningful because Spreetail lists on Amazon; work this list down so every product it should carry is identified."
      tool="listSkuListingGaps"
      args={{ limit: 200 }}
      select={(r) => (r as { gaps: GapRow[] }).gaps ?? []}
      columns={COLUMNS}
      rowKey={(r) => r.sku_id}
      emptyMessage="No listing gaps — every active SKU has an Amazon ASIN."
      refreshable
    />
  );
}
